import { Stack, Typography, Link, useTheme } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import React from "react"
import { Invoice } from "#/pages/inbound-member-payments/lib/InboundMemberPaymentsClient"
import moment from "moment"

type ReimbursementsListReconciliationExpenseStatesProps = {
  isLoading: boolean
  isError: boolean
  invoices: Invoice[]
}

export const ReimbursementsListReconciliationExpenseStates = ({
  isLoading,
  isError,
  invoices
}: ReimbursementsListReconciliationExpenseStatesProps) => {
  const intl = useIntl()
  const openInvoice = invoices?.find((invoice) => invoice.status === "open")
  const paidInvoices = invoices?.filter((invoice) => invoice.status === "paid")
  const reconciliationCreatedDate = openInvoice && moment.unix(openInvoice.dateCreated).format("MMM DD")
  const theme = useTheme()

  return (
    <Stack spacing={theme.tokens.spacing.xs}>
      {isLoading && (
        <Typography variant="body2" color="textSecondary" marginBottom={(theme) => theme.tokens.spacing.xxs}>
          <FormattedMessage defaultMessage="Loading invoice information..." />
        </Typography>
      )}
      {isError && (
        <Typography variant="body2" color="error" marginBottom={(theme) => theme.tokens.spacing.xxs}>
          <FormattedMessage defaultMessage="Failed to load invoice information" />
        </Typography>
      )}
      {openInvoice && (
        <Stack spacing={theme.tokens.spacing.xxs}>
          <Typography variant="body2" color={(theme) => theme.palette.text.tertiary} id="reconciliation-created-date">
            <FormattedMessage
              defaultMessage="Reconciliation requested on {reconciliationCreatedDate}"
              values={{ reconciliationCreatedDate }}
            />
          </Typography>
          <Link
            href={openInvoice.invoicePaymentUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            color="inherit"
          >
            {intl.formatMessage({ defaultMessage: "Make payment" })}
          </Link>
        </Stack>
      )}
      {paidInvoices &&
        paidInvoices.length > 0 &&
        paidInvoices.map((invoice) => (
          <Stack key={invoice.invoicePaymentUrl} spacing={theme.tokens.spacing.xxs}>
            <Typography variant="body2" color={(theme) => theme.palette.text.tertiary} id="reconciliation-paid-date">
              <FormattedMessage
                defaultMessage="Reconciled on {reconciliationPaidDate}"
                values={{ reconciliationPaidDate: moment.unix(invoice.datePaid).format("MMM DD") }}
              />
            </Typography>
            <Link
              href={invoice.invoicePaymentUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              color="inherit"
            >
              {intl.formatMessage({ defaultMessage: "View receipt" })}
            </Link>
          </Stack>
        ))}
    </Stack>
  )
}
